__turbopack_context__.v({
  "root": "display-icon-module-scss-module__I89qPq__root",
  "u-animation-bounce": "display-icon-module-scss-module__I89qPq__u-animation-bounce",
});
